import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./auth";
import { categoryReducer } from "./category";
import createSagaMiddleware from "redux-saga";
import { rootSaga } from "./saga";
import { audiobookReducer } from "./audiobook";
import { bannerAdsReducer } from "./banner-ads";

const rootReducer = combineReducers({
  auth: authReducer,
  categories: categoryReducer,
  audiobook: audiobookReducer,
  bannerAds: bannerAdsReducer,
});

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type GlobalState = ReturnType<typeof store.getState>;

export default store;
